import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const PatternNumbers = ({patternNumber, setPatternNumber, patterns}) => { 
    let arr = new Array(patterns).fill(0);
    return (
        <div className="pattern-numbers">
          {arr.map((a, i) => <Pattern pattern={i} isCurrent={patternNumber === i} setPatternNumber={setPatternNumber}/>)}
        </div>
    );
}

const Pattern = ({pattern, isCurrent, setPatternNumber}) => {
    let className = "mini-pattern-btn";
    if (isCurrent) {
        className += " current";
    }
    return (
        <div className={className} onClick={() => setPatternNumber(pattern)}>
          {pattern + 1}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatternNumbers);
